// src/components/ui/layout/PageContainer/PageContainer.jsx
import React from 'react';
import { cn } from '../../../../utils/cn';

const PageContainer = ({
  children,
  className = '',
  padding = 'default',
  background = 'gradient',
  maxWidth = 'full',
  // Height constraint mode for viewport-contained layouts
  heightMode = 'auto', // 'auto' (default) | 'viewport'
  ...props
}) => {
  // Padding options
  const paddingOptions = {
    none: '',
    sm: 'p-4',
    default: 'p-2',
    lg: 'p-12',
    xl: 'p-16'
  };

  // Background options - now using shadcn color variables
  const backgroundOptions = {
    none: '',
    solid: 'bg-background',
    gradient: 'bg-background', // Use semantic background color
    custom: '' // For when you want to pass your own background
  };

  // Max width options
  const maxWidthOptions = {
    'sm': 'max-w-sm',
    'md': 'max-w-md', 
    'lg': 'max-w-lg',
    'xl': 'max-w-xl',
    '2xl': 'max-w-2xl',
    '3xl': 'max-w-3xl',
    '4xl': 'max-w-4xl',
    '5xl': 'max-w-5xl',
    '6xl': 'max-w-6xl',
    '7xl': 'max-w-7xl',
    'full': 'max-w-full'
  };


  if (heightMode === 'viewport') {
    return (
      <div
        className={cn(
          // Viewport mode - fill available height with flex column
          'h-full flex flex-col',

          // Background
          backgroundOptions[background],

          // Padding
          paddingOptions[padding],

          className
        )}
        {...props}
      >
        {/* Content Container with Max Width */}
        <div className={cn('w-full h-full flex flex-col mx-auto', maxWidthOptions[maxWidth])}>
          {children}
        </div>
      </div>
    );
  }

  // Default mode - auto height
  return (
    <div
      className={cn(
        'h-full',

        // Background
        backgroundOptions[background],

        // Padding
        paddingOptions[padding],

        className
      )}
      {...props}
    >
      <div className={cn('mx-auto space-y-6', maxWidthOptions[maxWidth])}>
        {children}
      </div>
    </div>
  );
};

export default PageContainer;